<script setup lang="ts">
  import type { IHeaderLogo } from '@/components/main-header/types'
  import useHeaderDataLayer from '@/composables/data-layers/useHeaderDataLayer'

  const props = withDefaults(
    defineProps<{
      logo: IHeaderLogo
      provider?: string
    }>(),
    {
      provider: 'storyblok'
    }
  )

  const backgroundColor = computed(() => {
    const defaultBgColor = 'bg-bt-green'
    const bgColorMapping: { [key: string]: string } = {
      white: 'white',
      'green-base': defaultBgColor,
      'blue-dark': 'bg-bt-blue-dark'
    }

    return bgColorMapping[props.logo.background] ?? defaultBgColor
  })

  const { locale } = useI18n()
  const localePath = useLocalePath()
  const route = useRoute()
  const linkPath = computed(() => localePath('/index', locale.value))

  const isHomepage = computed(() => route.meta.pageType === 'index')

  const { pushHeaderLogoClickDataLayer } = useHeaderDataLayer()
</script>

<template>
  <NuxtLink
    :to="linkPath"
    :title="logo.icon.alt"
    class="flex items-center justify-center rounded-r-full p-5 md:px-10 md:py-6"
    :class="backgroundColor"
    :aria-label="$t('aria.label.logo')"
    :aria-current="isHomepage ? 'page' : undefined"
    external
    @click="pushHeaderLogoClickDataLayer"
  >
    <NuxtImg
      v-if="logo.icon.src"
      :provider="provider"
      :src="logo.icon.src"
      :alt="logo.icon.alt"
      class="h-4 w-auto md:h-7"
      loading="eager"
    />
  </NuxtLink>
</template>
